import React from "react";
import SignUpComponent from "@/components/Authentication/SignupComponent";

export const SignUp = () => {
  return (
    <div>
      <SignUpComponent />
    </div>
  );
};
